<h2 mat-dialog-title>Remover {{data.type}}</h2>
<mat-dialog-content class="mat-typography">
  <p>Você tem certeza que deseja remover o {{data.type}} <b>{{data.name | uppercase}}</b>.</p>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: space-between">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="true">Remover</button>
</mat-dialog-actions>
